import Helper from './Helper';
import FurtherLinks from "./FurtherLinks";

class MovePrevNext {

  constructor(config = {}) {
    const {
    } = config;
    this.container = document.querySelector('.content-container');
    if(this.container){
      this.moreLinksContainer = this.container.querySelector('.ns-further-links');
    }
    if(this.moreLinksContainer){
      this.prevNext = document.querySelector('.prev-next');
      this.container.appendChild(this.prevNext);
      this.container.appendChild(this.moreLinksContainer.cloneNode(true))
      this.moreLinksContainer.remove();
      // since somehow lazyload breaks...
      [...document.querySelectorAll('.content-container .ns-img--further-links img')].forEach(img => {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.classList.add('loaded');
      });
    }

    new FurtherLinks({
      accordions: '.ns-further-links__title'
    });
  }
}

export default MovePrevNext;
